import api from "../../api";

export default {
  getCustomerAccessSettings() {
    return api.get("system-settings/customer-access");
  },
  resolveCustomerAccessPaste(params) {
    return api.post("system-settings/customer-access/resolve-paste", params);
  },
  storeCustomerAccess(params) {
    return api.post("system-settings/customer-access", params);
  },
  updateCustomerAccess(id, params) {
    return api.put(`system-settings/customer-access/${id}`, params);
  },
  deleteCustomerAccess(id) {
    return api.delete(`system-settings/customer-access/${id}`);
  },
};
